module.exports = __webpack_public_path__ + "img/tm.42a11ebc.svg";